import { useContext } from 'react';
import { BookMeetingModalContext } from './bookMeetingModalContext';

export function useBookMeetingModal() {
  return useContext(BookMeetingModalContext);
}
